import React, { useState } from 'react'
import {
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    WhatsappIcon
} from 'react-share';

function SocialMediaShare({ url, title }) {
    const [isOpen, setIsOpen] = useState(false);

    const togglePopup = () => {
        setIsOpen(!isOpen);
        // console.log("title====>", title);
    };

    let whatsApp = `whatsapp://send?text=${title}&amp;url=${url}`
    let facebook = `https://www.facebook.com/sharer/sharer.php?u=${url}`
    let linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`
    let twitter = `https://twitter.com/intent/tweet?text=${title}&url=${url}`
    return (
        <div>
            <button onClick={togglePopup} className='download-btn'>Share</button>
            {isOpen && (
                <div className="share-popup">
                    <a href={whatsApp}><WhatsappIcon size={32} round /></a>
                    <a href={facebook} target='_blank'><FacebookIcon size={32} round /></a>
                    <a href={linkedin} target='_blank'><LinkedinIcon size={32} round /></a>
                    <a href={twitter} target='_blank'><TwitterIcon size={32} round /></a>

                </div>
            )}
        </div>
    )
}

export default SocialMediaShare
